import { cva } from 'class-variance-authority';
export const pillStyling = cva('px-stack-roomy py-stack-tight rounded-pill text-caption whitespace-nowrap', {
    variants: {
        variant: {
            default: 'bg-bg-subtle text-neutral-fg',
            success: 'bg-success-subtle text-success-fg',
            error: 'bg-danger-subtle text-danger-fg',
            info: 'bg-info-subtle text-info-fg',
            warning: 'bg-warning-subtle text-warning-fg',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
